import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Typography } from '@mui/material';
import { 
  PlayArrow as StartIcon, 
  Stop as EndIcon 
} from '@mui/icons-material';

const StartEndNode = ({ data, isConnectable, selected }) => {
  const isStart = data.nodeType === 'start';
  const IconComponent = isStart ? StartIcon : EndIcon;
  
  return (
    <Box
      sx={{
        padding: '12px 20px',
        borderRadius: '50px',
        background: selected 
          ? (isStart 
              ? 'linear-gradient(45deg, #10B981 30%, #34D399 90%)' 
              : 'linear-gradient(45deg, #EF4444 30%, #F87171 90%)')
          : (isStart 
              ? 'linear-gradient(45deg, #10B981 30%, #059669 90%)'
              : 'linear-gradient(45deg, #EF4444 30%, #DC2626 90%)'),
        color: 'white',
        border: selected 
          ? (isStart ? '2px solid #059669' : '2px solid #DC2626') 
          : 'none',
        boxShadow: selected 
          ? (isStart 
              ? '0 4px 20px rgba(16, 185, 129, 0.4)' 
              : '0 4px 20px rgba(239, 68, 68, 0.4)')
          : (isStart 
              ? '0 2px 15px rgba(16, 185, 129, 0.2)'
              : '0 2px 15px rgba(239, 68, 68, 0.2)'),
        minWidth: '120px',
        textAlign: 'center',
        position: 'relative',
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: isStart 
            ? '0 4px 25px rgba(16, 185, 129, 0.3)' 
            : '0 4px 25px rgba(239, 68, 68, 0.3)',
          transform: 'translateY(-2px) scale(1.05)'
        }
      }}
    >
      {!isStart && (
        <Handle
          type="target"
          position={Position.Top}
          isConnectable={isConnectable}
          style={{
            background: '#DC2626',
            width: 10,
            height: 10,
            border: '2px solid #fff'
          }}
        />
      )}
      
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
        <IconComponent sx={{ fontSize: 20 }} />
        <Typography 
          variant="body2" 
          sx={{ 
            fontWeight: 700,
            fontSize: '0.9rem',
            letterSpacing: '0.5px'
          }}
        >
          {data.label}
        </Typography>
      </Box>
      
      {data.description && (
        <Typography 
          variant="caption" 
          sx={{ 
            opacity: 0.9,
            display: 'block',
            mt: 0.5,
            fontSize: '0.7rem'
          }}
        >
          {data.description}
        </Typography>
      )}

      {/* Pulsing effect for start node */}
      {isStart && (
        <Box
          sx={{
            position: 'absolute',
            top: -2,
            left: -2,
            right: -2,
            bottom: -2,
            borderRadius: '50px',
            border: '2px solid rgba(16, 185, 129, 0.3)',
            animation: 'pulse 2s infinite',
            '@keyframes pulse': {
              '0%': {
                transform: 'scale(1)',
                opacity: 0.7
              },
              '50%': {
                transform: 'scale(1.1)',
                opacity: 0.3
              },
              '100%': {
                transform: 'scale(1)',
                opacity: 0.7
              }
            }
          }}
        />
      )}
      
      {isStart && (
        <Handle
          type="source"
          position={Position.Bottom}
          isConnectable={isConnectable}
          style={{
            background: '#059669',
            width: 10,
            height: 10,
            border: '2px solid #fff'
          }}
        />
      )}
    </Box>
  );
};

export default memo(StartEndNode);